import { Button, Popover } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import React, { FC, useState } from 'react';
import { EnumClosingCostType } from '../../../../types/settings';
import ClosingCostFormPopover from './ClosingCostFormPopover';

type Props = {
  reportId: string;
  updateRows?: {
    text: string;
    amount: number;
    closingCostId: number;
    editable: boolean;
    type: EnumClosingCostType;
    propertyTaxesMonthsCollected: number;
    daysCollected: number;
  }[];
  refetchData?: () => void;
  isActive: boolean;
}

const UpdateClosingCost: FC<Props> = ({ reportId, updateRows, refetchData, isActive }) => {
  const [isPopoverOpen, setPopoverOpen] = useState(false);

  const handleOpenChange = () => {
    setPopoverOpen(prev => isActive ? !prev : false);
  };

  return (
    <Popover
      open={isPopoverOpen}
      trigger="click"
      placement="right"
      title={<span>Update</span>}
      overlayClassName="closing-cost-popover"
      onOpenChange={handleOpenChange}
      content={
        <ClosingCostFormPopover
          reportId={reportId ?? ''}
          updateRows={updateRows}
          refetchData={refetchData}
          isEditMode
          setPopoverOpen={setPopoverOpen}
          isPopoverOpen={isPopoverOpen}
        />
      }
    >
      <Button
        type="link"
        icon={<EditOutlined />}
        style={{ marginRight: 4 }}
        disabled={!isActive}
      />
    </Popover>
  )
}

export default UpdateClosingCost;
